import {
  AreaFragmentDto,
  ClientConfigurationDormerSpecificSettingsClientVariableSettingsDto,
  ConfigurationTemplateDormerOverhangDto, FaceConfigurationDto,
  FaceDto,
  FrameDto,
  FrameVariation, OrderDto,
  SectionFragmentDto,
  SectionFragmentSide,
  SectionFragmentType
} from "@hec/api-dtos";
import {fromMmToRenderingMeters} from "./NumberHelpers";
import {DormerRootState, getFaceConfiguration, GetSectionFragmentByTypeFromFace, getSouthFaceFromOrder} from "@hec/dal";

export const ROOF_OVERHANG_OFFSET = 200;


export const getStubbedHeight = (face: FaceDto | undefined): number => {
  const sectionFragments = face?.sectionFragments ?? [];
  const stubbed = sectionFragments.find(x => x.sectionFragmentType === SectionFragmentType.Stubbed);
  const stubbedHeight = stubbed?.height ?? 0;

  return returnWarnWrongNumber(stubbedHeight);
}

const  FRAME_SURROUNDING_ROD_THICKNESS = 50;

export const getFrameSurroundingRodThickness = (
  sf: SectionFragmentDto | undefined | null,
  cvSettings: ClientConfigurationDormerSpecificSettingsClientVariableSettingsDto
): number => {
  const viableSf = sf?.sectionFragmentType === SectionFragmentType.FrameSurroundingRod ? sf : null;

  const result = viableSf?.width ?? cvSettings.sizeFrameSurroundingRod ?? FRAME_SURROUNDING_ROD_THICKNESS;
  return returnWarnWrongNumber(result);
}

export const getAreaFragmentHeight = (
  // face: FaceDto,
  // faceConfiguration?: FaceConfigurationDto
  order: OrderDto
): number => {

  const faceConfiguration = order?.faceConfiguration;
  if(faceConfiguration == null){
    return 0;
  }

  const face = getSouthFaceFromOrder(order);
  if(face == null){
    return 0;
  }
  const dormerHeight = faceConfiguration?.height ?? 0;

  if (dormerHeight === 0) {
    return 0;
  }
  const stubbedHeight: number = getStubbedHeight(face);
  const upSplinterHeight: number = getUpSplinterHeight(face);
  const downSplinterHeight: number = getDownSplinterHeight(face);

  const height = dormerHeight - (stubbedHeight + upSplinterHeight + downSplinterHeight);

  return height;
};

export const getWindowInsetHeight = (
  order: OrderDto,
  clientVariables: ClientConfigurationDormerSpecificSettingsClientVariableSettingsDto
): number => {
  const areaFragmentHeight = getAreaFragmentHeight(order);
  if(areaFragmentHeight === 0) {
    return 0;
  }


  const face = getSouthFaceFromOrder(order);
  const frameSurroundingRod = GetSectionFragmentByTypeFromFace(face!, SectionFragmentType.FrameSurroundingRod);
  // const clientVariables: ClientConfigurationDormerSpecificSettingsClientVariableSettingsDto =
  const surroundingRodWidth = getFrameSurroundingRodThickness(frameSurroundingRod, clientVariables);
  return areaFragmentHeight - surroundingRodWidth * 2
};


export const getFrameOpeningFrameRodRodThickness = (
  sf: SectionFragmentDto | undefined | null,
  cvSettings: ClientConfigurationDormerSpecificSettingsClientVariableSettingsDto
): number => {

  const result = cvSettings.sizeOpeningFrameRod;
  return returnWarnWrongNumber(result);
}


export const getFrameSeparatorRodRodThickness = (
  sf: SectionFragmentDto | undefined | null,
  cvSettings: ClientConfigurationDormerSpecificSettingsClientVariableSettingsDto
): number => {
  const result = cvSettings.sizeFramesSeparatorRod;
  return returnWarnWrongNumber(result);
}

export const getUpSplinterHeight = (face: FaceDto | undefined) => {
  const sectionFragments = face?.sectionFragments ?? [];
  const splinters = sectionFragments.filter(x => x.sectionFragmentType === SectionFragmentType.Splinter);
  const upSplinter = splinters.find(x => x.splinterSide === SectionFragmentSide.Up);

  return upSplinter?.height ?? 0;
}

export const getDownSplinterHeight = (face: FaceDto | undefined) => {
  const sectionFragments = face?.sectionFragments ?? [];
  const splinters = sectionFragments.filter(x => x.sectionFragmentType === SectionFragmentType.Splinter);
  const downSplinter = splinters.find(x => x.splinterSide === SectionFragmentSide.Down) ??
    splinters.find(x => x.splinterSide === SectionFragmentSide.EastPlusSouthPlusWest);

  return downSplinter?.height ?? 0;
}

export const getEastSplinterWidth = (face: FaceDto | undefined) => {
  const sectionFragments = face?.sectionFragments ?? [];
  const splinters = sectionFragments.filter(x => x.sectionFragmentType === SectionFragmentType.Splinter);
  const eastSplinter = splinters.find(x => x.splinterSide === SectionFragmentSide.East) ??
    splinters.find(x => x.splinterSide === SectionFragmentSide.EastPlusWest) ??
    splinters.find(x => x.splinterSide === SectionFragmentSide.EastPlusSouthPlusWest);

  return eastSplinter?.width ?? 0;
}

export const getWestSplinterWidth = (face: FaceDto | undefined) => {
  const sectionFragments = face?.sectionFragments ?? [];
  const splinters = sectionFragments.filter(x => x.sectionFragmentType === SectionFragmentType.Splinter);
  const westSplinter = splinters.find(x => x.splinterSide === SectionFragmentSide.West) ??
    splinters.find(x => x.splinterSide === SectionFragmentSide.EastPlusWest) ??
    splinters.find(x => x.splinterSide === SectionFragmentSide.EastPlusSouthPlusWest);

  return westSplinter?.width ?? 0;
}

export const getSplinterHeightFromSectionFragments = (sectionFragments: SectionFragmentDto[]) => {
  // const sectionFragments = face?.sectionFragments ?? [];
  const splinters = sectionFragments.filter(x => x.sectionFragmentType === SectionFragmentType.Splinter);
  const upSplinter = splinters.find(x => x.splinterSide === SectionFragmentSide.Up);
  const downSplinter = splinters.find(x => x.splinterSide === SectionFragmentSide.Down) ??
    splinters.find(x => x.splinterSide === SectionFragmentSide.EastPlusSouthPlusWest);

  return (upSplinter?.height ?? 0) + (downSplinter?.height ?? 0);
}

export const getFullSplinterHeight = (face: FaceDto | undefined) => {
  return getUpSplinterHeight(face) + getDownSplinterHeight(face);
}

export const getFullSplinterWidth = (face: FaceDto | undefined) => {
  return getEastSplinterWidth(face) + getWestSplinterWidth(face);
}


export const getCheeksWidth = (face: FaceDto | undefined, cheekSide: SectionFragmentSide | undefined = undefined) => {
  const sectionFragments = face?.sectionFragments ?? [];
  const cheeksSectionFragments = sectionFragments.filter(x =>
    x.sectionFragmentType === SectionFragmentType.Cheeks);

  const desiredSectionFragment = cheeksSectionFragments.find(x =>
    x.cheekSide === cheekSide
  ) ?? cheeksSectionFragments.find(x =>
    x.cheekSide === SectionFragmentSide.EastPlusWest
  );

  const cheeksSectionFragment = desiredSectionFragment ?? cheeksSectionFragments.find(x => !!x);

  const cheeksWidth = cheeksSectionFragment?.width ?? 0;
  return returnWarnWrongNumber(cheeksWidth)
}

// Duplicate off hec-client/libs/dal/src/lib/Order/Util/GetAreaFragmentsFromFace.ts
// This ofcourse going to be very temporary and i will remember to replace it and not find this comment 3 years down the line finding it mildly amusing
const GetAreaFragmentsFromFace = (face: FaceDto): AreaFragmentDto[] => {
  const result = face.sectionFragments.filter(x => x.sectionFragmentType === SectionFragmentType.AreaFragment) ?? [];
  return result as AreaFragmentDto[];
}


export const getWidthOfAreaFragmentsFromFace = (face: FaceDto | undefined): number => {
  if (!face) {
    return 0;
  }

  const areaFragments = GetAreaFragmentsFromFace(face).filter(x => x.faceId != null);

  const areaFragmentWidth = areaFragments.map(x => x.width ?? 0);

  const result = areaFragmentWidth.reduce((sum, num) => sum + num, 0);

  return returnWarnWrongNumber(result);
}


export const getWidthOfFramesFromFace = (face: FaceDto | undefined): number => {
  const width = getWidthOfAreaFragmentsFromFace(face);
  if (width > 1) {
    return width;
  }
  console.error("Could not determine width using AreaFragments(calculationhelper getWidthOfAreaFragmentsFromFace, falling back to frames. THIS IS DEPRECATED");


  // Frames no longer dictate width.
  const sectionFragments = face?.sectionFragments ?? [];

  // return 0;
  return getWidthOfFrames(sectionFragments);
}

export const getWidthOfFrames = (sectionFragments: SectionFragmentDto[]): number => {

  const frameSectionFragments = sectionFragments.filter(x => x.sectionFragmentType === SectionFragmentType.Frame);

  const frameSectionsWidth = frameSectionFragments.map(x => x.width)
  const totalWidthOfFrames = frameSectionsWidth.reduce((accumulator, currentValue) => {
    return accumulator + currentValue
  }, 0);

  return returnWarnWrongNumber(totalWidthOfFrames);
}

export const getFrameHeight = (face: FaceDto | undefined): number => {
  const sectionFragments = face?.sectionFragments ?? [];
  const frameSectionFragments = sectionFragments.find(x => x.sectionFragmentType === SectionFragmentType.Frame);

  return frameSectionFragments?.height ?? 0;
}


export const getTotalHeightExcludingStubbedAndframeSurroundingRodThickness = (face: FaceDto | undefined): number => {
  const sectionFragments = face?.sectionFragments ?? [];

  const frameHeight = getFrameHeight(face);
  const splinterHeight = getFullSplinterHeight(face);
  const frameSurroundingRod = GetSectionFragmentByTypeFromFace(face!, SectionFragmentType.FrameSurroundingRod);
  const frameSurroundingRodWidth = frameSurroundingRod?.width ?? 0;

  const result = frameHeight + splinterHeight + frameSurroundingRodWidth * 2;

  return returnWarnWrongNumber(result);
}


export const getTotalHeight = (face: FaceDto | undefined): number => {

  const frameHeight = getFrameHeight(face);

  const splinterHeight = getFullSplinterHeight(face);

  const stubbedHeight = getStubbedHeight(face);

  const result = frameHeight + (splinterHeight * 2) + stubbedHeight;

  return returnWarnWrongNumber(result);
}


// The sizes of these are not mutable by the customer
export const getWidthOfStaticSections = (face: FaceDto | undefined): number => {
  const sectionFragments = face?.sectionFragments ?? [];

  const splinterWidth = getFullSplinterWidth(face);

  const cheeksSectionFragment = sectionFragments.find(x => x.sectionFragmentType === SectionFragmentType.Cheeks);
  const cheeksWidth = cheeksSectionFragment?.width ?? 0;

  const result = (splinterWidth * 2) + (cheeksWidth * 2);

  return returnWarnWrongNumber(result);
}


export const getTotalWidth = (face: FaceDto | undefined): number => {
  const totalWidthOfNonAreaFragments = GetTotalWidthOfNonAreaFragments(face);
  const result = getWidthOfFramesFromFace(face) + (totalWidthOfNonAreaFragments ?? 0);

  return returnWarnWrongNumber(result);
}

export const GetTotalWidthOfNonAreaFragments = (face: FaceDto | undefined) => {

  if (!face) {
    return null;
  }
  const splinterWidth = getFullSplinterWidth(face);


  const eastCheekWidth = getCheeksWidth(face, SectionFragmentSide.East);
  const westCheekWidth = getCheeksWidth(face, SectionFragmentSide.West);

  const cheeksWidth = eastCheekWidth + westCheekWidth;


  return (splinterWidth) + (cheeksWidth);
}

export const getThickestSplinterSide = (face: FaceDto | undefined): number => {
  const sectionFragments = face?.sectionFragments ?? [];

  const splinter = sectionFragments.find(x => x.sectionFragmentType === SectionFragmentType.Splinter);
  const splinterWidth = splinter?.width ?? 0;
  const splinterHeight = splinter?.height ?? 0;

  const result = splinterWidth > splinterHeight ? splinterWidth : splinterHeight;

  return returnWarnWrongNumber(result);
}


export const getTotalFramePlusSplinterWidth = (face: FaceDto | undefined): number => {
  const splinterWidth = getFullSplinterWidth(face);

  const result = getWidthOfFramesFromFace(face) + splinterWidth;

  return returnWarnWrongNumber(result);
}

export const getFrames = (face: FaceDto | undefined): FrameDto[] => {
  const sectionFragments = face?.sectionFragments ?? [];
  const frames: FrameDto[] = sectionFragments.filter(x => x.sectionFragmentType === SectionFragmentType.Frame) as FrameDto[];

  return frames;
}


const MOCK_PANEL_ID = "MOCK_PANEL_ID";

export const getMaxFrameIndex = (face: FaceDto | undefined): number | null => {
  const frames = getFrames(face);

  const nonMockPanels = frames.filter(x => x.id !== MOCK_PANEL_ID && x.sort != null && x.sort > -1);

  if (nonMockPanels.length === 0) {
    return null;
  }

  const sorts: number[] = nonMockPanels.map(x => x.sort!);

  const max = Math.max(...sorts);
  return max;
}


export const getMockFillerPanel = (face: FaceDto | null, width: number | null, height: number | null): SectionFragmentDto | null => {

  if (!face || !width || !height) {
    return null;
  }

  const reservedWidth = getCheeksWidth(face) * 2 + getFullSplinterWidth(face);

  const widthOfFrames = getWidthOfFramesFromFace(face);

  const desiredWidth = width - (reservedWidth + widthOfFrames);

  if (desiredWidth < 1) {
    return null;
  }


  const cheek: SectionFragmentDto | undefined = (face.sectionFragments ?? []).find(x => x.sectionFragmentType === SectionFragmentType.Cheeks);

  const reservedHeight = getFullSplinterHeight(face) + getStubbedHeight(face);

  const desiredHeight = height - reservedHeight;


  const maxFrameIndex = getMaxFrameIndex(face);

  const result: FrameDto = {
    name: "Filler",
    dormerMaterialId: "",
    // TODO: Add
    // dormerMaterial: ,
    minWidth: null,
    maxWidth: null,
    minHeight: null,
    maxHeight: null,
    variation: FrameVariation.Panel,
    supportedSizes: [],
    priceCalculationStrategyId: null,
    isSelectableFrame: false,
    id: MOCK_PANEL_ID,
    faceId: null,
    copiedFromId: null,
    // copiedFrom: new SectionFragmentDto,
    sort: maxFrameIndex !== null ? (maxFrameIndex + 1) : 0,
    width: desiredWidth,
    height: desiredHeight,
    sectionFragmentType: SectionFragmentType.Frame,
    isDefaultForTemplate: false,
    organisationId: null,
    orderId: null,
    configurationTemplateId: null,
    faceConfigurationId: "",
    isOrganisationAddable: false,
    isUserSelectable: false,
    belongsToUser: false,
    configuredDormerColor: cheek?.configuredDormerColor,
    configuredDormerColorId: cheek?.configuredDormerColor?.id
  } as unknown as FrameDto;

  return result;
}

export const degreesToRadians = (degrees: number) => {
  return degrees * (Math.PI / 180);
}


export const returnWarnWrongNumber = (num: number) => {

  if (num < 1) {
    console.warn(`renderig num was ${num}`);
    return 1;
  }

  return num;
}

export class RoofOverhangViewModel {
  stubbedSouthOverhang: number;
  stubbedEastOverhang: number;
  stubbedWestOverhang: number;

  constructor(stubbedSouthOverhang: number, stubbedEastOverhang: number, stubbedWestOverhang: number) {
    this.stubbedSouthOverhang = stubbedSouthOverhang;
    this.stubbedEastOverhang = stubbedEastOverhang;
    this.stubbedWestOverhang = stubbedWestOverhang;
  }
}


export const getRoofOverhang = (overhangDto: ConfigurationTemplateDormerOverhangDto): RoofOverhangViewModel =>
  new RoofOverhangViewModel(fromMmToRenderingMeters(overhangDto.stubbedSouthOverhang), fromMmToRenderingMeters(overhangDto.stubbedEastOverhang), fromMmToRenderingMeters(overhangDto.stubbedWestOverhang));

